<template>
    <ul class="pagination" :class="[size && `pagination-${size}`, align && `justify-content-${align}`]">
      <li class="page-item prev-page" :class="{disabled: modelValue === 1}">
        <a class="page-link pointer" aria-label="Previous" @click="prevPage">
          <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
        </a>
      </li>
      <li class="page-item"
          :key="item"
          v-for="item in range(minPage, maxPage)">
        <a class="page-link pointer" :style="modelValue === item ? customActive : ''" @click="changePage(item)">{{item}}</a>
      </li>
      <li class="page-item next-page" :class="{disabled: modelValue === totalPages}">
        <a class="page-link pointer" aria-label="Next" @click="nextPage">
          <span aria-hidden="true"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        </a>
      </li>
    </ul>
  </template>
<script>
export default {
    emits: ['input', 'update:modelValue'],
    name: 'base-pagination',
    props: {
        pageCount: {
            type: Number,
            default: 0,
            description:
          'Pagination page count. This should be specified in combination with perPage',
        },
        perPage: {
            type: Number,
            default: 10,
            description:
          'Pagination per page. Should be specified with total or pageCount',
        },
        total: {
            type: Number,
            default: 0,
            description:
          'Can be specified instead of pageCount. The page count in this case will be total/perPage',
        },
        modelValue: {
            type: Number,
            default: 1,
            description: 'Pagination value',
        },
        size: {
            type: String,
            default: '',
            description: 'Pagination size',
        },
        align: {
            type: String,
            default: '',
            description: 'Pagination alignment (e.g center|start|end)',
        },
        type: {
            type: String,
            default: '',
        },
        visiblePages: {
            type: Number,
            default: 5, // Número padrão de páginas visíveis
            description: 'Número de páginas visíveis na paginação',
        },
    },
    computed: {
        totalPages() {
            if (this.pageCount > 0) return this.pageCount;
            if (this.total > 0) {
                return Math.ceil(this.total / this.perPage);
            }
            return 1;
        },
        pagesToDisplay() {
            return Math.min(this.totalPages, this.visiblePages);
        },
        minPage() {
            if (this.modelValue >= this.pagesToDisplay) {
                const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
                const newMaxPage = pagesToAdd + this.modelValue;
                if (newMaxPage > this.totalPages) {
                    return this.totalPages - this.pagesToDisplay + 1;
                }
                return this.modelValue - pagesToAdd;
            }
            return 1;
        },
        maxPage() {
            if (this.modelValue >= this.pagesToDisplay) {
                const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
                const newMaxPage = pagesToAdd + this.modelValue;
                if (newMaxPage < this.totalPages) {
                    return newMaxPage;
                }
                return this.totalPages;
            }
            return this.pagesToDisplay;
        },
        customActive() {
            return {
                backgroundColor: this.type,
                borderColor: this.type,
                color: '#FFF',
            };
        },
    },
    data() {
        return {
            defaultPagesToDisplay: 5,
        };
    },
    methods: {
        range(min, max) {
            const arr = [];
            for (let i = min; i <= max; i++) {
                arr.push(i);
            }
            return arr;
        },
        changePage(item) {
            this.$emit('update:modelValue', item);
            this.$emit('input', item);
        },
        nextPage() {
            if (this.modelValue < this.totalPages) {
                this.$emit('update:modelValue', this.modelValue + 1);
                this.$emit('input', this.modelValue + 1);
            }
        },
        prevPage() {
            if (this.modelValue > 1) {
                this.$emit('update:modelValue', this.modelValue - 1);
                this.$emit('input', this.modelValue - 1);
            }
        },
    },
    watch: {
        perPage() {
            this.$emit('update:modelValue', 1);
            this.$emit('input', 1);
        },
        total() {
            this.$emit('update:modelValue', 1);
            this.$emit('input', 1);
        },
    },
};
</script>

  <style scoped>
  .pointer {
    cursor: pointer;
  }
  </style>
